import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useGetTaskResourceUserAllocationsSummaryForUser } from '~/modules/tasks/hooks';
import RepliconPopover from '~/modules/common/components/RepliconPopover';
import useProjectAllocationForResourceUser from '../hooks/useProjectAllocationForResourceUser';
import ProjectManagerRoleEditorContent from './ProjectManagerRoleEditorContent';
import ResourceManagerRoleEditorContent from './ResourceManagerRoleEditorContent';
import TaskAllocationEditorContextProvider from './TaskAllocationEditorContextProvider';

const usePopoverStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    width: theme.spacing(64),
    minHeight: theme.spacing(9),
    minWidth: theme.spacing(64)
  }
}));

const TaskAllocationEditor = ({
  anchorEl,
  setAnchorEl,
  userId,
  projectId,
  taskResourceUserAllocation,
  canEditResourceAllocation
}) => {
  const { loading, resourceAllocation } = useProjectAllocationForResourceUser({
    projectId,
    userId
  });

  const {
    loading: summaryLoading,
    taskResourceUserAllocationsSummary: otherTaskAllocationsSummary
  } = useGetTaskResourceUserAllocationsSummaryForUser({
    userId,
    projectId,
    taskAllocationId: taskResourceUserAllocation?.id
  });

  const popoverClasses = usePopoverStyles();

  const onClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return (
    <TaskAllocationEditorContextProvider>
      <RepliconPopover
        id="task-allocation-editor"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        classes={popoverClasses}
        horizontalAlign="right"
      >
        {canEditResourceAllocation ? (
          <ResourceManagerRoleEditorContent
            onClose={onClose}
            otherTaskAllocationsSummary={otherTaskAllocationsSummary}
            resourceAllocation={resourceAllocation}
            isLoading={loading || summaryLoading}
          />
        ) : (
          <ProjectManagerRoleEditorContent
            onClose={onClose}
            otherTaskAllocationsSummary={otherTaskAllocationsSummary}
            resourceAllocation={resourceAllocation}
            isLoading={loading || summaryLoading}
          />
        )}
      </RepliconPopover>
    </TaskAllocationEditorContextProvider>
  );
};

TaskAllocationEditor.propTypes = {
  anchorEl: PropTypes.object,
  setAnchorEl: PropTypes.func,
  projectId: PropTypes.string,
  userId: PropTypes.string,
  taskResourceUserAllocation: PropTypes.object,
  canEditResourceAllocation: PropTypes.bool
};

export default TaskAllocationEditor;
